import React from 'react';
import Link from 'gatsby-link';
import trackLead from '../../trackLead';
import Logo from '../assets/logo-2.svg';

const Navbar = () => {
  return (
    <nav className="w-full relative z-10">
      <div className="container">
        <div className="flex flex-row justify-end py-4 items-center leading-5">
          <div className="flex flex-1">
            <Link
              to="/"
              className="flex justify-start text-shop-dark-green no-underline mr-4"
            >
              <Logo height="50" width="50" />
            </Link>
          </div>
          <Link
            to="/pricing"
            className="font-sans text-sm hover:opacity-75 text-shop-dark-green no-underline mr-4"
          >
            Pricing
          </Link>
          <Link
            to="/faq"
            className="font-sans text-sm hover:opacity-75 text-shop-dark-green no-underline mr-4"
          >
            FAQ
          </Link>
          <a
            className="inline-flex rounded-full border-2 border-shop-dark-green hover:bg-shop-dark-green hover:text-white px-4 py-1 text-sm leading-5 tracking-wider text-shop-dark-green transition duration-300 ease-in-out"
            href="https://apps.shopify.com/shopfeedback"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackLead()}
          >
            Sign up
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
